<ng-container *ngIf="message">
    <div class="m-portlet__body no-padding-bottom">
        <div class="m-section__content">
            <ngb-alert [type]="message.type" [dismissible]="false">
                {{message.text}}
            </ngb-alert>
        </div>
    </div>
</ng-container>
